import { createCustomSelector } from '@utils/functions.js';
import { sectionTypes } from '@utils/sectionEnums.js';

export const selectMembershipRequesting = (state) => state.membership.requesting;
export const selectMembershipError = (state) => state.membership.error;

export const selectMembershipId = (state) => state.membership.id;
export const selectMembershipUID = (state) => state.membership.uid;
export const selectMembershipSID = (state) => state.membership.sid;
export const selectMembershipIsAdded = (state) => state.membership.isAdded;
export const selectMembershipIsActive = (state) => state.membership.isActive;

export const selectMembershipView = (state) => state.membership.view;
export const selectMembershipItems = (state) => state.membership.items;

export const selectHeadingObj = createCustomSelector(sectionTypes.membership.type);
